<pt-details-layout
  [infoMessage]="infoMessage"
  [noDataMessage]="noDataMessage"
  [showInfo]="showInfo"
  [showNoData]="showNoData"
  [showWarning]="showWarning"
  [title]="title"
  [warningMessage]="warningMessage">
  <ng-container body>
    <div (click)="openDetails()" *ngIf="!showNoData" class="dcard-container">
      <pt-entity-icon [entity]='entity' [width]='30' style="margin-right: 10px"></pt-entity-icon>
      <div class="details-link"> {{ text }}</div>
    </div>
  </ng-container>
</pt-details-layout>

